// const Postings = () => {
//   return (
//     <div>
//       <h2 className="text-2xl font-semibold mb-4">Contact Forms</h2>
//       <p>This is where all the job postings will appear.</p>
//     </div>
//   );
// };

// export default Postings;

import React, {useState} from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem,
  Stack,
} from '@mui/material';
import axios from 'axios';
//import { useNavigate } from 'react-router-dom';

//const jobTypes = ['Full-Time', 'Part-Time', 'Internship', 'Contract'];

const PostJobForm = () => {

  const [formData, setFormData] = useState({
      position:'',
      summary:'',
      responsibilities:'',
      education:'',
      experience:'',
      skills:'',
      offer:'',
      location:'',
      applydate:''
    });
  
    const [message, setMessage] = useState('');
    //const navigate = useNavigate();
  
    // const handleChange = (e) => {
    //   setFormData({ ...formData, [e.target.name]: e.target.value });
    // };

    const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prevData) => ({
    ...prevData,
    [name]: value
  }));
};

const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('/api/posts', formData);
      setMessage(res.data.message);
      if (res.status === 200 || res.status === 201) {
        console.log("Job is posted");
        // Redirect to dashboard
        //navigate('/dashboard');
          const job = res.data.newjob; // 👈 This is where user.email comes from
       console.log('job', job);
       alert("Job posted successfully");
      // ✅ Store email in session storage
      //sessionStorage.setItem('userEmail', user.email);
      //sessionStorage.setItem('userName', user.name); // Optional
        
      }
    } catch (error) {
      console.log(error);
      if (error.res?.data?.error) {
        setMessage(error.res.data.error);
      } else {
        setMessage("Something went wrong");
      }
    }
  };

  return (
    <Paper elevation={3} sx={{ maxWidth: 600, mx: 'auto', mt: 5, p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Post a New Job
      </Typography>

      <Stack spacing={3}>
        <TextField label="Job Title" variant="outlined" name="position" value={formData.position}  onChange={handleChange} fullWidth required />
        <TextField
          label="Job Position Summary"
           variant="outlined"
           name="summary"
           value={formData.summary}
           onChange={handleChange}
           multiline
           rows={6}
          fullWidth
          required
        />
        <TextField
          label="Key Responsibilities"
          variant="outlined"
          name="responsibilities"
          value={formData.responsibilities}
          onChange={handleChange}
          multiline
          rows={20}
          fullWidth
          required
        />
        <TextField
          label="Education"
          variant="outlined"
          name="education"
          value={formData.education}
          onChange={handleChange}
          multiline
          rows={6}
          fullWidth
          required
        />
          {/* {jobTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField> */}
        <TextField
          label="Experience"
          variant="outlined"
          name="experience"
          value={formData.experience}
          onChange={handleChange}
          multiline
          rows={6}
          fullWidth
          required
        />
        <TextField
          label="Skills"
          variant="outlined"
          name="skills"
          value={formData.skills}
          onChange={handleChange}
          multiline
          rows={6}
          fullWidth
          required
        />
        <TextField
          label="What we offer"
          variant="outlined"
          name="offer"
          value={formData.offer}
          onChange={handleChange}
          multiline
          rows={6}
          fullWidth
          required
        />
        <TextField
          label="Location"
          variant="outlined"
          name="location"
          value={formData.location}
          onChange={handleChange}
          fullWidth
          required
        />
        <TextField
          label="Apply By"
          variant="outlined"
          name="applydate"
          value={formData.applydate}
          onChange={handleChange}
          fullWidth
          required
        />
        

        <Button variant="contained" color="primary" size="large" onClick={(e) => handleSubmit(e)}>
          Post Now
        </Button>
      </Stack>
    </Paper>
  );
};

export default PostJobForm;

